import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import './App.scss';
import './scss/_custom-bni.scss';
import Cookies from 'js-cookie';
import { generateUuid, getAppTheme } from './views/Commons/SharedLibrary';

const appTheme = getAppTheme();

const Loading = () => (
    <div className="animated fadeIn app text-center">
        <div className="sk-spinner sk-spinner-pulse" />
    </div>
);

const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

const Login = React.lazy(() => import('./views/Pages/Login/Login'));

const UpdatePassword = React.lazy(() => {
    switch (appTheme) {
        case 'DEFAULT':
            return import('./views/Pages/Register/UpdatePassword');
        case 'CONVERGENCE':
            return import('./views/Pages/Register/UpdatePasswordConvergence');
        default:
            return import('./views/Pages/Register/UpdatePassword');
    }
});

const VerifyEmail = React.lazy(() => import('./views/Pages/Register/VerifyEmail'));

const Register = React.lazy(() => {
    switch (appTheme) {
        case 'DEFAULT':
            return import('./views/Pages/Register/Register');
        case 'CONVERGENCE':
            return import('./views/Pages/Register/RegisterConvergence');
        default:
            return import('./views/Pages/Register/Register');
    }
});

const RegisterUncdf = React.lazy(() => import('./views/Pages/Register/RegisterUncdf'));
const RegisterParticipant = React.lazy(() => import('./views/Pages/Register/RegisterParticipant'));
const TokenExpirationCheck = React.lazy(() =>
    import('./views/Pages/Register/TokenExpirationCheck')
);

const BNIRedirect = React.lazy(() => import('./views/Pages/Login/BNIRedirect'));

if (appTheme.includes('CONVERGENCE')) {
    import('./App-convergence.scss').then(null);
} else if (appTheme.includes('CIMB')) {
    import('./App-cimb.scss').then(null);
} else if (appTheme.includes('BNI')) {
    import('./App-bni.scss').then(null);
} else {
    import('./App.scss').then(null);
}

const App = () => {
    useEffect(() => {
        // * generate unique device uuid
        const deviceId = Cookies.get('deviceId') ?? null;
        if (!deviceId) {
            Cookies.set('deviceId', generateUuid(), {
                path: '/',
                expires: 2147483647,
            });
        }
    }, []);

    return (
        <div style={{ background: 'white' }} className="font-style">
            <Suspense fallback={<Loading />}>
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/bnidirect" component={BNIRedirect} />
                        <Route exact path="/login" name="Login Page" component={Login} />
                        <Route
                            exact
                            path="/update-password/:uuid"
                            name="Update Password"
                            component={UpdatePassword}
                        />
                        <Route
                            exact
                            path="/verify-email/:rt"
                            name="Verify Email"
                            component={VerifyEmail}
                        />
                        <Route
                            exact
                            path="/register/:rt"
                            name="Register Page"
                            component={RegisterUncdf}
                        />
                        <Route
                            exact
                            path="/token-expiration-check/:rt/:page"
                            name="Token Expiration Check"
                            component={TokenExpirationCheck}
                        />
                        <Route
                            exact
                            path="/participant-registration/:token"
                            name="Participant Registration Page"
                            component={RegisterParticipant}
                        />
                        <Route exact path="/register" name="Register Page" component={Register} />
                        <Route path="/" name="Home" component={DefaultLayout} />
                    </Switch>
                </BrowserRouter>
            </Suspense>
        </div>
    );
};

export default App;
